// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"326a60d6","455":"3eea1548"}[chunkId] + ".chunk.js";
};